import { throttle } from 'lodash';
import { useLayoutEffect } from 'react';

const useLayoutChanged = (callback: () => void) => {
    const throttledCallback = throttle(callback, 100);

    useLayoutEffect(() => {
        throttledCallback();
    });
};

export default useLayoutChanged;
